import DataGrid2 from '../../..';

export async function updateColumnCells(this: DataGrid2, columnName: string, value: any) {
	await this.set(
		'rows',
		this.rows.map(row => {
			return {
				...row,
				cells: row.cells.map(cell => {
					if (cell.name === columnName) {
						return {
							...cell,
							text: value?.toString?.() || '',
							value: value
						};
					}

					return cell;
				}),
				data: {
					...row.data,
					[columnName]: value
				}
			};
		})
	);
}
